/* eslint-disable */
import { SaveCancelFooter } from '@/components/molecules'
import { ROUTES } from '@/utils/constants/routesConstants'
import { ReviewAccordion, ReviewActionHeader } from '@/containers'
import { useAppDispatch, useAppSelector } from '@/store'
import { PageHeader } from 'pepsico-ds'
import { useCallback, useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { setLanguages, setToastNotifications } from '@/store/slices/commonSlice'
import { ProgressIndicator, Breadcrumb, Modal, CardSkeletonLoader } from '@/components/atoms'
import { addSalesTargetList, getSalesTargetData, getSalesTargetsDownloadMedia, addDraftSalesTargetList, updateDraftSalesTargetList } from '@/services/salesTargets'
import { resetSalesTarget, setSalesTarget, setSalesTargetDisplayContentMedia, setSalesTargetFormData, setSelectedType, setInitialTargetName, setSalesTargetSelectedCategory, setSalesTargetIsAllCategories, addPreRequisiteParentTab, addPreRequisiteChildTab, setRuleSet, setTargetType, setPageActiveTab } from '@/store/slices/salesTargetSlice'
import { useParams } from 'react-router-dom'
import { getISOTimeString, getDateFromISOString, getUUID } from '@/utils/commons'
import { MODAL_TYPE } from '@/utils/constants/globalStyle'
import { TARGET_TYPES, TARGET_TYPES_OPTIONS } from '@/utils/constants/saleTargetConstants'
import { downloadCSVFiles, getDateWithTimeString } from '@/helpers/shadcn/utils'
import { getSalesTargetsReporteDownload } from '@/services/salesTargets'
import { Constants } from '@/utils/constants/commonConstants'
import { getDisplayContentLanguagesService } from '@/services/languageService'
import { useProductList } from '@/containers/ProductsContainer/SalesTargetProducts/useProductList'
import { set } from 'lodash'

export const SalesTargetReview = () => {
  const [isCancel, setIsCancel] = useState(false)
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const salesTargetData = useAppSelector(state => state.salesTarget)
  const [isOpenStoreListModal, setOpenStoreListModal] = useState(false)
  const initialTargetName = salesTargetData?.initialTargetName;
  const [isReadOnly, setIsReadOnly] = useState(false)
  const { productListData } = useProductList({ isReviewPage: true })
  const PreRequisiteParent = {
    categoryTable: true,
    uploadFile: false
  }
  const PreRequisiteChild = {
    categoryTable: true,
    uploadFile: false
  }
  const [preRequisiteParentTab, setPreRequisiteParentTab] = useState({
    categoryTable: false,
    uploadFile: false
  })
  const [preRequisiteChildTab, setPreRequisiteChildTab] = useState({
    categoryTable: false,
    uploadFile: false
  })
  const productSelections = useAppSelector(state => state.salesTarget.productSelections)

  const [editModeProductIds, setEditModeProductIds] = useState({
    includedIds: [],
    excludedIds: [],
    childExcludedIds: [],
    childIncludedIds: []
  });

  const getFilteredProducts = (tabType) => {
    if (!productListData?.data || !productListData?.data?.length) {
      return []
    }

    let excludedIds = []
    let includedIds = []

    const parentTabData = salesTargetData.tabWiseData?.parent;
    const childTabData = salesTargetData.tabWiseData?.child;
    
    if (tabType === 'parent') {
      const parentRuleData = parentTabData?.ruleSet?.rules?.[0];
      excludedIds = parentTabData?.excludedProducts || parentRuleData?.excludedProductIds || [];
      includedIds = parentTabData?.includedProducts || parentRuleData?.includedProductIds || [];
    } else if (tabType === 'child') {
      const childRuleData = childTabData?.ruleSet?.rules?.[0];
      excludedIds = childTabData?.excludedProducts || childRuleData?.excludedProductIds || [];
      includedIds = childTabData?.includedProducts || childRuleData?.includedProductIds || [];
    }
    
  if (excludedIds.length === 0 && includedIds.length === 0) {
    if (id) {
      if (tabType === 'child') {
        excludedIds = editModeProductIds.childExcludedIds || [];
        includedIds = editModeProductIds.childIncludedIds || [];
      } else {
        excludedIds = editModeProductIds.excludedIds || [];
        includedIds = editModeProductIds.includedIds || [];
      }
    }
    else if (productSelections) {
      if (tabType === 'parent') {
        excludedIds = productSelections?.parent?.excluded || []
        includedIds = productSelections?.parent?.included || []
      } else if (tabType === 'child') {
        excludedIds = productSelections?.child?.excluded || []
        includedIds = productSelections?.child?.included || []
      } else {
        excludedIds = productSelections?.all?.excluded || []
        includedIds = productSelections?.all?.included || []
      }
    } else {
      return []
  }
  }

    const relevantProductIds = [...excludedIds, ...includedIds]
    const filteredProducts = productListData.data
      .filter(product => relevantProductIds.includes(product.productId))
      .map(product => ({
        ...product,
        category: product.category_locale || product.category_en,
        brand: product.brand_locale || product.brand_en,
        included: includedIds.includes(product.productId)
      }))

    return filteredProducts
  }

  useEffect(() => {
    setListData({ ...salesTargetData, ...dataList })
  }, [productListData, editModeProductIds])

  const [dataList, setListData] = useState({ ...salesTargetData })

  const displayContentLanguages = useAppSelector(state => state.common?.languages || [])
  const [activeLanguage, setActiveLanguage] = useState('en')
  const handleTabClick = langCode => {
    setActiveLanguage(langCode)
  }


  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const urlStatus = searchParams.get('status');
  const isPrerequisiteTarget =
    salesTargetData?.targetType === TARGET_TYPES.MonthlyTargetPrerequistite ||
    salesTargetData?.targetType === TARGET_TYPES.ProductTargetPrerequisite
  const isLayeredTarget = salesTargetData?.targetType === TARGET_TYPES.ProductTargetLayered || salesTargetData?.targetType === TARGET_TYPES.MonthlyTargetLayered
  const isMainTargetOrProdTarget = salesTargetData?.targetType === TARGET_TYPES.MainTarget || salesTargetData?.targetType === TARGET_TYPES.ProductTarget
  const createReqObj = () => {
    const result = {
      targetName: salesTargetData?.targetName, // You can change this if you want to dynamically set this
      displayContent: {
        en: salesTargetData?.displayContent?.en,
        es_MX: salesTargetData?.displayContent?.es,
      },
      ignoreSkuList: salesTargetData?.tabWiseData?.parent?.ignoreSkuList,
      targetType: salesTargetData?.targetTypeValue || "",
      joinCampaignFlag: salesTargetData?.joinCampaignFlag,
      VATIncluded: salesTargetData?.VATIncluded,
      roundPointsValue: salesTargetData?.roundPointsValue,
      roundUpPointsFlag: salesTargetData?.roundUpPointsFlag,
      offlineOrdersIncluded: salesTargetData?.offlineOrdersIncluded,
      cepRefId: salesTargetData?.cepRefId,
      displayStartDate: getISOTimeString(salesTargetData?.displayStartDate, false, true),
      displayEndDate: getISOTimeString(salesTargetData?.displayEndDate, true, false),
      activeStartDate: getISOTimeString(salesTargetData?.activeStartDate, false, true),
      activeEndDate: getISOTimeString(salesTargetData?.activeEndDate, true, false),
      targetDeliveryDate: getISOTimeString(salesTargetData?.targetEndDate, true, false),
      pointsDeliveryDate: getISOTimeString(salesTargetData?.pointsDeliveryDate, true, false),
      pointDisplay: isLayeredTarget ? salesTargetData?.pointDisplay : null,
      ruleSet: salesTargetData?.tabWiseData?.parent?.ruleSet,
      media: salesTargetData?.media,
      childRuleSet: salesTargetData?.childRuleSet,
      status: salesTargetData?.status,
      awardPointsImmedFlag: isMainTargetOrProdTarget ? salesTargetData?.awardPointsImmedFlag : null,
      storeList: salesTargetData?.storeList,
      metadata: {
        productFileName: salesTargetData?.selectedType === Constants.UploadedProducts ? salesTargetData?.tabWiseData?.parent?.mediaFile[0] : null,
        isProductIdsUploaded: salesTargetData?.selectedType === Constants.UploadedProducts ? true : false,
        numberLevel: isLayeredTarget ? salesTargetData?.numberLevel : null,
        numberMileStone: isLayeredTarget ? salesTargetData?.numberMileStone : null,
      }
    }
    return result
  }
  const createPreReqReqObj = () => {
    const result = {
      storeList: salesTargetData?.storeList || [],
      targetName: salesTargetData?.targetName || "",
      ruleSet: salesTargetData?.tabWiseData?.parent?.ruleSet,
      targetType: salesTargetData?.targetTypeValue || "",
      awardPointsImmedFlag: salesTargetData?.awardPointsImmedFlag ?? false,
      joinCampaignFlag: salesTargetData?.joinCampaignFlag,
      VATIncluded: true,
      cepRefId: salesTargetData?.cepRefId ?? null,
      childRuleSet: null,
      roundPointsValue: salesTargetData?.roundPointsValue || "",
      roundUpPointsFlag: salesTargetData?.roundUpPointsFlag ?? false,
      activeStartDate: getISOTimeString(salesTargetData?.activeStartDate, false, true),
      activeEndDate: getISOTimeString(salesTargetData?.activeEndDate, false, true),
      targetDeliveryDate: getISOTimeString(salesTargetData?.targetDeliveryDate, false, true),
      displayStartDate: getISOTimeString(salesTargetData?.displayStartDate, false, true),
      displayEndDate: getISOTimeString(salesTargetData?.displayEndDate, false, true),
      pointsDeliveryDate: getISOTimeString(salesTargetData?.pointsDeliveryDate, false, true),
      media: salesTargetData?.media,
      displayContent: {
        es_MX: salesTargetData?.displayContent?.es,
        en: salesTargetData?.displayContent?.en,
      },
      ignoreSkuList: salesTargetData?.tabWiseData?.child?.ignoreSkuList ?? false,
      offlineOrdersIncluded: salesTargetData?.offlineOrdersIncluded ?? false,
      pointDisplay: null,
      child: {
        id: "",
        storeList: "",
        targetName: salesTargetData?.targetName || "",
        ruleSet: salesTargetData?.tabWiseData?.child?.ruleSet,
        displayContent: {
          es_MX: salesTargetData?.child?.displayContent?.es,
          en: salesTargetData?.child?.displayContent?.en,
        },
        targetType: salesTargetData?.targetTypeValue || "",
        awardPointsImmedFlag: salesTargetData?.awardPointsImmedFlag ?? false,
        joinCampaignFlag: true,
        VATIncluded: true,
        cepRefId: salesTargetData?.cepRefId ?? null,
        childRuleSet: null,
        roundPointsValue: salesTargetData?.roundPointsValue || "",
        roundUpPointsFlag: salesTargetData?.roundUpPointsFlag ?? false,
        activeStartDate: getISOTimeString(salesTargetData?.activeStartDate, false, true),
        activeEndDate: getISOTimeString(salesTargetData?.activeEndDate, false, true),
        targetDeliveryDate: getISOTimeString(salesTargetData?.targetDeliveryDate, false, true),
        displayStartDate: getISOTimeString(salesTargetData?.displayStartDate, false, true),
        displayEndDate: getISOTimeString(salesTargetData?.displayEndDate, false, true),
        media: salesTargetData?.media,
        status: salesTargetData?.status,
        ignoreSkuList: salesTargetData?.tabWiseData?.parent?.ignoreSkuList ?? false,
        offlineOrdersIncluded: salesTargetData?.offlineOrdersIncluded ?? false,
        pointDisplay: null,
        children: [],
        application: {
          createdAt: "",
          updatedAt: "",
          createdBy: null,
          updatedBy: null,
          id: "",
          country: "",
          siteId: "",
          timezone: "",
          pointsMultiplierRuleSet: {
            rules: [
              {
                name: "Order Channel",
                matchWith: [
                  "online"
                ],
                multiplier: 2.0
              },
              {
                name: "Order Channel",
                matchWith: [
                  "offline"
                ],
                multiplier: 1.5
              }
            ]
          },
          config: null
        },
        parent: null,
        totalTasks: null,
        metadata: {
          productFileName: salesTargetData.tabWiseData.child.mediaFile.length == 1 ? salesTargetData?.tabWiseData?.child?.mediaFile[0] : '',
          isProductIdsUploaded: salesTargetData.tabWiseData.child.mediaFile.length == 1 ? true : false
        }

      },
      application: null,
      parent: null,
      totalTasks: null,
      metadata: {
        productFileName: salesTargetData.tabWiseData.parent.mediaFile.length == 1 ? salesTargetData?.tabWiseData?.parent?.mediaFile[0] : '',
        isProductIdsUploaded: salesTargetData.tabWiseData.parent.mediaFile.length == 1 ? true : false
      }

    }
    return result
  }


  const handlePublishAction = async () => {
    const reqObj = isPrerequisiteTarget ? createPreReqReqObj() : createReqObj()
    try {
      const response = await addSalesTargetList({ data: reqObj })
      if (Object.keys(response).length > 0) {
        dispatch(setToastNotifications({ show: true, message: 'New Sales Target published', type: 'success' }))
        dispatch(resetSalesTarget())
        navigate(ROUTES.SALES_TARGETS)
      } else dispatch(setToastNotifications({ show: true, message: 'New Sales Target not published', type: 'error' }))
    } catch (err) {
      console.log(err)
    }
  }
  const handleDraft = async () => {
    let isTargetNameChanged = (initialTargetName === null) || (initialTargetName !== salesTargetData?.targetName)
    const reqObj = isPrerequisiteTarget ? createPreReqReqObj() : createReqObj()
    if (reqObj.targetName === null) {
      dispatch(setToastNotifications({ show: true, message: 'Target Name is required', type: 'error' }))
      return;
    }
    reqObj.status = 'Draft';
    reqObj['uuid'] = isTargetNameChanged ? getUUID(reqObj.targetName) : getUUID(initialTargetName);
    let response;
    if (isTargetNameChanged) {
      response = await addDraftSalesTargetList({ data: reqObj })
    } else {
      response = await updateDraftSalesTargetList({ data: reqObj })
    }
    if (response.success) {
      dispatch(resetSalesTarget())
      dispatch(setToastNotifications({ show: true, message: 'New Sales Target Drafted', type: 'info' }))
      navigate(ROUTES.SALES_TARGETS)
    } else dispatch(setToastNotifications({ show: true, message: 'New Sales Target not Drafted', type: 'error' }))
  }

  const handleCancel = () => {
    setIsCancel(!isCancel)
  }
  const createFormData = obj => {

    const isLayeredTarget =
      TARGET_TYPES_OPTIONS[obj?.targetType] === TARGET_TYPES.MonthlyTargetLayered || TARGET_TYPES_OPTIONS[obj?.targetType] === TARGET_TYPES.ProductTargetLayered

    const formData = {
      targetType: TARGET_TYPES_OPTIONS[obj?.targetType] ?? obj?.targetType,
      targetTypeValue: obj?.targetType,
      targetName: obj?.targetName,
      storeList: obj?.storeList,
      ruleSet: obj?.ruleSet,
      awardPoint: obj?.awardPointsImmedFlag,
      pointsDeliveryDate: getDateFromISOString(obj?.pointsDeliveryDate),
      targetEndDate: getDateFromISOString(obj?.targetDeliveryDate),
      startDate: getDateFromISOString(obj?.activeStartDate),
      excludeTaxFromGoal: !obj?.VATIncluded,
      userNeedsToJoin: obj?.joinCampaignFlag,
      includeOfflineHours: obj?.offlineOrdersIncluded,
      endDate: getDateFromISOString(obj?.activeEndDate),
      ignoreSkuList: obj?.ignoreSkuList,
      displayStartDate: getDateFromISOString(obj?.displayStartDate),
      displayEndDate: getDateFromISOString(obj?.displayEndDate),
      numberLevel: obj?.metadata?.numberLevel,
      numberMileStone: obj?.metadata?.numberMileStone,
      roundUpPointsFlag: obj?.metadata?.roundUpPointsFlag,
      // this may require in future
      // roundOffValue: obj?.roundPointsValue,
      // roundOffValueValid: obj?.roundPointsValue > 0 ? true : false,
      pointDisplay: isLayeredTarget ? obj?.pointDisplay : null,
      pointDisplayValid: isLayeredTarget ? false : null,
    }
    return formData
  }

  const createDisplayContent = (obj) => {
    const displayContentObj = obj?.displayContent || {}

    const otherLangKey = Object.keys(displayContentObj).find(key => key !== 'en')

    const displayContent = {
      en: {
        targetType: displayContentObj?.en?.targetType,
        title: displayContentObj?.en?.title,
        parentCategory: displayContentObj?.en?.parentCategory,
        childCategory: displayContentObj?.en?.childCategory,
        excerpt: displayContentObj?.en?.excerpt,
        terms: displayContentObj?.en?.terms,
        titleValid: displayContentObj?.en?.titleValid,
        excerptValid: displayContentObj?.en?.excerptValid,
        termsValid: displayContentObj?.en?.termsValid,
      },
      es: otherLangKey ? {
        targetType: displayContentObj?.[otherLangKey]?.targetType,
        title: displayContentObj?.[otherLangKey]?.title,
        titleValid: displayContentObj?.[otherLangKey]?.titleValid,
        excerpt: displayContentObj?.[otherLangKey]?.excerpt,
        excerptValid: displayContentObj?.[otherLangKey]?.excerptValid,
        terms: displayContentObj?.[otherLangKey]?.terms,
        termsValid: displayContentObj?.[otherLangKey]?.termsValid,
      } : undefined
    }

    return displayContent
  }
  const fetchImage = async (imageUri) => {
    let response = null;
    let url = null;
    try {
      response = await getSalesTargetsDownloadMedia("filePath=" + imageUri);
      url = URL.createObjectURL(response);
    } catch (error) {
      console.error('Download error:', error);
    }
    return url;
  }
  let changeParam = id
  let [loading, setLoading]= useState(false)
  const getSalesDataById = useCallback(
    async id => {
      try {
        changeParam = urlStatus === Constants.Draft ? 'uuid' : 'id';
        setLoading(true)
        const response = await getSalesTargetData(`${changeParam}=${id}`);
        setLoading(false)
        let imageUri = null;

        let parentRulesObj = null;
        let childRulesObj = null;

        if (response.data.length > 0 || response?.data?.content?.length > 0) {

          let composedData = {};
          if (urlStatus === Constants.Draft) {
            if (response?.data?.content[0]?.versionData?.media[0]?.imageUrl) {
              imageUri = await fetchImage(response?.data?.content[0]?.versionData?.media[0]?.imageUrl);
            }
            const displayContent = createDisplayContent(response?.data?.content[0]?.versionData);
            const childDisplayContentCopy = response?.data?.content[0]?.versionData?.child ? response?.data?.content[0]?.versionData?.child : {}
            const childDisplayContent = createDisplayContent(childDisplayContentCopy);
            composedData = {
              ...dataList, formData: createFormData(response?.data?.content[0]?.versionData),
              ruleSet: response?.data?.content[0]?.versionData?.ruleSet,
              displayContent: displayContent,
              targetName: response?.data?.content[0]?.versionData?.targetName,
              // this needs to be changes once get proper data found
              child: { displayContent: childDisplayContent },
              status: response?.data?.content[0]?.versionData?.status,
              pointDisplay: response?.data?.content[0]?.versionData?.pointDisplay,
              joinCampaignFlag: response?.data?.content[0]?.versionData?.joinCampaignFlag,
              displayContentMedia: response?.data?.content[0]?.versionData?.media.length > 0 ? {
                ...response?.data?.content[0]?.versionData?.media[0],
                title: response?.data?.content[0]?.versionData?.media[0]?.title,
                imageUrl: response?.data?.content[0]?.versionData?.media[0]?.imageUrl,
                imageUri: imageUri,
              } : {},
              targetType: TARGET_TYPES_OPTIONS[response?.data?.content[0]?.versionData?.targetType],
              tabWiseData: {
                parent: {
                  ruleSet: response?.data?.content[0]?.versionData?.ruleSet,
                  mediaFile: response?.data?.content[0]?.versionData?.metadata?.isProductIdsUploaded ? [response?.data?.content[0]?.versionData?.metadata?.productFileName] : [],
                  selectedCategory: response?.data?.content[0]?.versionData?.ruleSet?.rules[0]?.includedCategories,
                },
                child: {
                  ruleSet: response?.data?.content[0]?.versionData?.child?.ruleSet,
                  mediaFile: response?.data?.content[0]?.versionData?.child?.metadata?.isProductIdsUploaded ? [response?.data?.content[0]?.versionData?.child?.metadata?.productFileName] : [],
                  selectedCategory: response?.data?.content[0]?.versionData?.child?.ruleSet?.rules[0]?.includedCategories,
                }
              }
            }
            dispatch(setSalesTarget(composedData))
            if (response?.data?.content[0]?.versionData?.metadata?.isProductIdsUploaded) {
              dispatch(setSelectedType(Constants?.UploadedProducts));
              setPreRequisiteParentTab({
                categoryTable: false,
                uploadFile: true
              });
            } else {
              dispatch(setSelectedType(Constants?.CategoryProducts));
              setPreRequisiteParentTab({
                categoryTable: true,
                uploadFile: false
              });
            }
            if ((response?.data?.content[0]?.versionData?.targetType == 'Monthly Prerequisite Target' || response?.data?.content[0]?.versionData?.targetType == 'Product Prerequisite Target') && response?.data?.content[0]?.versionData?.child?.metadata?.isProductIdsUploaded) {
              setPreRequisiteChildTab({
                categoryTable: false,
                uploadFile: true
              });
            } else {
              setPreRequisiteChildTab({
                categoryTable: true,
                uploadFile: false
              });
            }

          } else {
            
            if(response?.data[0]?.media[0]?.imageUrl){
              imageUri = await fetchImage(response?.data[0]?.media[0]?.imageUrl);

            }
            const formData = createFormData(response?.data[0]);
            const displayContent = createDisplayContent(response?.data[0]);
            const childDisplayContent = createDisplayContent(response?.data[0]?.children[0] || {});
            composedData = {
              ...dataList, formData: formData, ruleSet: response?.data[0]?.ruleSet, displayContent: displayContent,
              targetName: response?.data[0]?.targetName,
              child: { displayContent: childDisplayContent },
              status: response?.data[0]?.status,
              pointDisplay: response?.data[0]?.pointDisplay,
              joinCampaignFlag: response?.data[0]?.joinCampaignFlag,
              displayContentMedia: {
                ...response?.data[0]?.media[0],
                title: response?.data[0]?.media[0]?.title,
                imageUrl: response?.data[0]?.media[0]?.imageUrl,
                imageUri: imageUri,
              },
              targetType: TARGET_TYPES_OPTIONS[response?.data[0]?.targetType],
              tabWiseData: {
                parent: {
                  ruleSet: response?.data[0]?.ruleSet,
                  mediaFile: response?.data[0]?.metadata?.isProductIdsUploaded ? [response?.data[0]?.metadata?.productFileName] : [],
                  selectedCategory: response?.data[0]?.ruleSet?.rules[0]?.includedCategories,
                },
                child: {
                  ruleSet: response?.data[0]?.children[0]?.ruleSet,
                  mediaFile: response?.data[0]?.children[0]?.metadata?.isProductIdsUploaded ? [response?.data[0]?.children[0]?.metadata?.productFileName] : [],
                  selectedCategory: response?.data[0]?.children[0]?.ruleSet?.rules[0]?.includedCategories,
                }
              },
            }
          }
          dispatch(setSalesTarget(composedData))
          if (response?.data[0]?.metadata?.isProductIdsUploaded) {
            dispatch(setSelectedType(Constants?.UploadedProducts));
            setPreRequisiteParentTab({
              categoryTable: false,
              uploadFile: true
            });
          } else {
            dispatch(setSelectedType(Constants?.CategoryProducts));
            setPreRequisiteParentTab({
              categoryTable: true,
              uploadFile: false
            });
          }

          if ((response?.data[0]?.targetType == 'Monthly Prerequisite Target' || response?.data[0]?.targetType == 'Product Prerequisite Target') && response?.data[0]?.children[0].metadata?.isProductIdsUploaded) {
            setPreRequisiteChildTab({
              categoryTable: false,
              uploadFile: true
            });
          } else {
            setPreRequisiteChildTab({
              categoryTable: true,
              uploadFile: false
            });
          }
          if (urlStatus === Constants.Draft) {
            parentRulesObj = response?.data?.content[0]?.versionData?.ruleSet?.rules?.[0];
          } else {
            parentRulesObj = response?.data[0]?.ruleSet?.rules?.[0];
          }

          if (urlStatus === Constants.Draft) {
            if (response?.data?.content[0]?.versionData?.child?.ruleSet?.rules?.[0]) {
              childRulesObj = response?.data?.content[0]?.versionData?.child?.ruleSet?.rules?.[0];
            }
          } else {
            if (response?.data[0]?.children && response?.data[0]?.children.length > 0) {
              childRulesObj = response?.data[0]?.children[0]?.ruleSet?.rules?.[0];
            }
          }

          // Extract parent and child product IDs
          const parentIncludedIds = parentRulesObj?.includedProductIds || [];
          const parentExcludedIds = parentRulesObj?.excludedProductIds || [];
          const parentAllProductIds = [...parentIncludedIds, ...parentExcludedIds];

          const childIncludedIds = childRulesObj?.includedProductIds || [];
          const childExcludedIds = childRulesObj?.excludedProductIds || [];
          const childAllProductIds = [...childIncludedIds, ...childExcludedIds];

          setEditModeProductIds({
            includedIds: parentIncludedIds,
            excludedIds: parentExcludedIds,
            childIncludedIds: childIncludedIds,
            childExcludedIds: childExcludedIds
          });

          const combinedIncludedIds = childAllProductIds.length > 0 ?
            [...parentIncludedIds, ...childIncludedIds] :
            parentIncludedIds;

          const combinedExcludedIds = childAllProductIds.length > 0 ?
            [...parentExcludedIds, ...childExcludedIds] :
            parentExcludedIds;

          // Create a single rule set with combined product IDs
          const updatedRuleSet = {
            includeAllProductsByDefault: parentRulesObj?.includeAllProductsByDefault || false,
            skipNonAssorted: false,
            rules: [
              {
                includedCategories: parentRulesObj?.includedCategories || [],
                includedProductIds: combinedIncludedIds,
                excludedCategories: parentRulesObj?.excludedCategories || [],
                excludedProductIds: combinedExcludedIds
              }
            ]
          };

          dispatch(setRuleSet({ ruleSet: updatedRuleSet }));
          dispatch(setInitialTargetName(composedData.targetName))
          setListData(composedData)
          dispatch(setTargetType(composedData.targetType))
          dispatch(
            setToastNotifications({ show: true, message: ' Sales Target data fetched succesfully', type: 'success' })
          )
        } else dispatch(setToastNotifications({ show: true, message: 'Sales Target data not fetched', type: 'error' }))
      } catch (err) {
        setLoading(false)
        console.log(err)
      }
    },
    [dataList, dispatch]
  )
  useEffect(() => {
    if (id) {
      getSalesDataById(id)
      setIsReadOnly(true)
      // get langauuge
      getDisplayContentLanguagesService().then(res => {
        dispatch(setLanguages(res))
      })
    }
  }, [id])

  useEffect(() => {
    if (id && productListData?.data?.length) {
      let dataWithIncluded = productListData.data.map(product => ({ ...product }))
      dispatch(setSalesTargetFormData({ selectedSalesTargetProduct: dataWithIncluded }))
    }
  }, [id, productListData])

  const onClickPrimaryButton = () => {
    dispatch(resetSalesTarget())
    navigate(ROUTES.SALES_TARGETS)
  }

  const onClickSecondaryButton = () => {
    setIsCancel(!isCancel)
  }

  //Handle duplicate sales target action
  const handleDuplicate = (route) => {
    if (dataList.formData) {
      const updatedDataList = JSON.parse(JSON.stringify(dataList));

      // Set status to Draft
      updatedDataList.status = Constants.Draft;

      // Reset target name
      updatedDataList.formData.targetName = null;
      updatedDataList.formData.targetNameValid = true;

      // Reset active display
      if (updatedDataList.formData.startDate == updatedDataList.formData.displayStartDate &&
        updatedDataList.formData.endDate == updatedDataList.formData.displayEndDate) {
        updatedDataList.formData.activeDisplay = true;
      }

      // Reset award point
      updatedDataList.formData.awardPoint = updatedDataList.formData.targetEndDate == updatedDataList.formData.pointsDeliveryDate;

      // Reset validation flags
      updatedDataList.formData.startDateValid = false;
      updatedDataList.formData.endDateValid = false;
      updatedDataList.formData.displayStartDateValid = false;
      updatedDataList.formData.displayEndDateValid = false;
      updatedDataList.formData.targetEndDateValid = false;
      updatedDataList.formData.pointsDeliveryDateValid = false;

      // Reset selection flags
      updatedDataList.formData.isNumberOfLevelsSelected = false;
      updatedDataList.formData.isNumberOfMilestonesSelected = false;

      // Reset dates if start date is in the past
      if (new Date(updatedDataList.formData.startDate) <= new Date()) {
        updatedDataList.formData.displayStartDate = null;
        updatedDataList.formData.displayEndDate = null;
        updatedDataList.formData.startDate = null;
        updatedDataList.formData.endDate = null;
        updatedDataList.formData.targetEndDate = null;
        updatedDataList.formData.pointsDeliveryDate = null;

        updatedDataList.formData.startDateValid = undefined;
        updatedDataList.formData.endDateValid = undefined;
        updatedDataList.formData.displayStartDateValid = undefined;
        updatedDataList.formData.displayEndDateValid = undefined;
        updatedDataList.formData.targetEndDateValid = undefined;
        updatedDataList.formData.pointsDeliveryDateValid = undefined;
      }

      // Restore Target CSV File
      updatedDataList.storeList = updatedDataList.formData.storeList;
      updatedDataList.formData.targetMediaFile = [updatedDataList.storeList];

      // Dispatch the updated state to Redux
      dispatch(setSalesTarget(updatedDataList));
      navigate(route);
    } else {
      navigate(route);
    }
  }

  const editDraftEntries = (route) => {
    if (dataList.formData && urlStatus === Constants?.Draft) {
      const updatedDataList = JSON.parse(JSON.stringify(dataList));
      updatedDataList.formData.targetName = updatedDataList.targetName;
      updatedDataList.formData.targetNameValid = false;
      updatedDataList.formData.startDateValid = false;
      updatedDataList.formData.endDateValid = false;
      updatedDataList.formData.displayStartDateValid = false;
      updatedDataList.formData.displayEndDateValid = false;
      updatedDataList.formData.targetEndDateValid = false;
      updatedDataList.formData.pointsDeliveryDateValid = false;
      updatedDataList.formData.isNumberOfLevelsSelected = false;
      updatedDataList.formData.isNumberOfMilestonesSelected = false;
      updatedDataList.formData.activeDisplay = true;
      updatedDataList.storeList = updatedDataList.formData.storeList;
      updatedDataList.formData.targetMediaFile = [updatedDataList.storeList];
      updatedDataList.initialTargetName = salesTargetData.initialTargetName;

      dispatch(setSalesTarget(updatedDataList))
      navigate(route)
    } else {
      navigate(route)
    }
  }
  const handleDownload = async () => {
    if (!id || urlStatus === Constants.Draft) return;
    try {
      const data = await getSalesTargetsReporteDownload(`salesTargetId=${id}`);
      const fileName = `SalesTarget_Report${getDateWithTimeString()}`;
      downloadCSVFiles(data, fileName);
    } catch (error) {
      dispatch(setToastNotifications({ show: true, message: 'Failed to download report', type: 'error' }));
    }
  };

  const editPanel = (route) => {
    editDraftEntries(route);
  }
  const handleSetActiveTab = () => {
    dispatch(setPageActiveTab({ activeTab: 'parent', pageTitle: 'Products' }));
  }
  return (
    <>
      <Breadcrumb
        uiSchema={{
          isDark: true,
          className: 'mb-5',
          breadcrumbs: [
            {
              href: '/',
              label: '',
            },
            {
              href: '',
              label: 'Loyalty Campaigns',
            },
            {
              href: '',
              label: 'Sales Target',
            },
            {
              href: '',
              label: 'Add Sales Target Mexico',
            },
          ],
        }}
        id={'str_bradcrumb'}
      />
      <PageHeader title={isReadOnly ? 'Sales Target Mexico' : 'Add Sales Target'} />
      { loading? <CardSkeletonLoader></CardSkeletonLoader>: 
      <>
      {!isReadOnly && <ProgressIndicator
        currentStep={4}
        completed={false}
        steps={4}
        titles={[{ title: 'Setup' }, { title: 'Display Content' }, { title: 'Products' }, { title: 'Review' }]}
        className="mb-6"
      />}
      {isReadOnly && <ReviewActionHeader
        completedDate={urlStatus !== Constants.Draft ? dataList?.formData?.activeEndDate ?? dataList?.formData?.endDate ?? "" : ""}
        onDuplicate={handleDuplicate}
        onDownload={handleDownload}
        isDuplicateEnabled={urlStatus !== Constants.Draft}
      />
      }
      <br />
      <ReviewAccordion
        salesTargetData={dataList}
        isOpenStoreListModal={isOpenStoreListModal}
        setOpenStoreListModal={setOpenStoreListModal}
        languages={displayContentLanguages}
        handleTabClick={handleTabClick}
        activeLanguage={activeLanguage}
        editPanel={editPanel}
        status={dataList?.status}
        preRequisiteParentTab={preRequisiteParentTab}
        preRequisiteChildTab={preRequisiteChildTab}
        handleSetActiveTab={handleSetActiveTab}
        getFilteredProducts={getFilteredProducts}
      />

      {isCancel ? (
        <Modal
          type={MODAL_TYPE.FLUID}
          showModal={isCancel}
          onCloseModal={handleCancel}
          title="Are you sure you want to cancel?"
          text={'Your work will not be saved if you click Yes. To continue editing and go back to the page, click NO'}
          showPrimaryButton={true}
          primaryButtonText="Yes"
          onClickPrimaryButton={onClickPrimaryButton}
          showSecondaryButton={true}
          secondaryButtonText="No"
          onClickSecondaryButton={onClickSecondaryButton}
          footerProps={{
            size: 'medium',
            type: 'primary',
          }}
          isDark={true}
        />
      ) : null}
      {!id ? (
        <SaveCancelFooter
          isReview={true}
          handleCancel={handleCancel}
          draftAction={handleDraft}
          nextAction={handlePublishAction}
        />
      ) : null}
    </>
    }
    </>
  )
}
